var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx } from '@emotion/core';
import { ButtonIcon } from './ButtonIcon';
import { styles as ButtonStyles, StyledButton } from './styles';
import { Spinner } from '../Spinner';

function makeLinkProps(href, target, download, disabled) {
  if (disabled === void 0) {
    disabled = false;
  }

  if (!href) {
    return {};
  }

  var downloadProp = download ? {
    download: download
  } : {};
  return __assign({
    href: disabled ? undefined : href,
    target: target,
    rel: !!target && target === '_blank' ? 'noopener noreferrer' : undefined
  }, downloadProp);
}

export var Button = function Button(_a) {
  var children = _a.children,
      _b = _a.appearance,
      appearance = _b === void 0 ? 'primary' : _b,
      href = _a.href,
      download = _a.download,
      target = _a.target,
      icon = _a.icon,
      _c = _a.iconPosition,
      iconPosition = _c === void 0 ? 'left' : _c,
      iconOverride = _a.iconOverride,
      _d = _a.loading,
      loading = _d === void 0 ? false : _d,
      _e = _a.disabled,
      disabled = _e === void 0 ? false : _e,
      _f = _a.stretch,
      stretch = _f === void 0 ? false : _f,
      _g = _a.size,
      size = _g === void 0 ? 'medium' : _g,
      _h = _a.onClick,
      onClick = _h === void 0 ? function () {} : _h,
      className = _a.className,
      testId = _a["data-testid"];
  var StyledComponent = href ? StyledButton.withComponent('a', {
    target: "e34b6f0",
    label: "StyledComponent"
  }) : StyledButton;
  var linkProps = makeLinkProps(href, target, download, disabled);
  return jsx(StyledComponent, __assign({
    disabled: disabled,
    size: size,
    stretch: stretch,
    appearance: appearance,
    onClick: disabled ? undefined : onClick,
    className: className,
    "data-testid": testId
  }, linkProps), jsx(ButtonIcon, {
    icon: icon,
    iconOverride: loading ? jsx(Spinner, {
      size: 16,
      color: ButtonStyles[appearance].accent.text
    }) : iconOverride,
    position: iconPosition
  }), children);
};
export default Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Button/index.js
// module id = 32
// module chunks = 0